import { initializeApp } from 'firebase/app';

import { getPortalRuntimeConfig } from '../services/runtimeConfig';

const { firebase } = getPortalRuntimeConfig();

export const firebaseConfig = {
  apiKey: firebase.apiKey,
  authDomain: firebase.authDomain,
  databaseURL: firebase.databaseUrl,
  projectId: firebase.projectId,
  storageBucket: firebase.storageBucket,
  messagingSenderId: firebase.messagingSenderId,
  appId: firebase.appId,
  measurementId: firebase.measurementId,
};
const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
